export const capitalize = (str) => {
    return !str ? '' : str.replace(/\b\w/g, c => c.toUpperCase());
};
